import { render, staticRenderFns } from "./Zuruck.vue?vue&type=template&id=2d84c01a&scoped=true"
import script from "./Zuruck.vue?vue&type=script&lang=js"
export * from "./Zuruck.vue?vue&type=script&lang=js"
import style0 from "./Zuruck.vue?vue&type=style&index=0&id=2d84c01a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d84c01a",
  null
  
)

export default component.exports